window.initComplementarySlider = function () {
  const sliders = document.querySelectorAll(".complementary-products--inner");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const wrapper = slider.closest(".complementary-products");
    if (!wrapper) return;

    let next = wrapper.querySelector(".next-arrow");
    let prev = wrapper.querySelector(".prev-arrow");

    if (next) {
      const newNext = next.cloneNode(true);
      next.parentNode.replaceChild(newNext, next);
      next = newNext;
    }

    if (prev) {
      const newPrev = prev.cloneNode(true);
      prev.parentNode.replaceChild(newPrev, prev);
      prev = newPrev;
    }

    let card =
      slider.querySelector(".product-card-small") ||
      slider.querySelector(".card-wrapper") ||
      slider.children[0];

    if (!card) return;

    let cardWidth = card.getBoundingClientRect().width;
    let gap = parseInt(getComputedStyle(slider).columnGap) || 16;
    let scrollAmount = cardWidth + gap;

    next?.addEventListener("click", () => {
      slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    prev?.addEventListener("click", () => {
      slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
  });
};

const COLOR_RADIO_SELECTOR =
  'input[type="radio"][data-variant-id][name="Farbe"], fieldset.product-form__input--color input[type="radio"][data-variant-id]';

function getVariantIdFromProductForm(container) {
  const input =
    container.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]:not([disabled])'
    ) ||
    container.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  return input && input.value ? String(input.value) : "";
}

function getCheckedColorVariantId(container) {
  const radio = container.querySelector(`${COLOR_RADIO_SELECTOR}:checked`);
  return radio && radio.dataset.variantId ? String(radio.dataset.variantId) : "";
}

function detectColorOptionKey(variant, variantSelects) {
  const colorNames = ["farbe", "color", "colour", "couleur", "kleur"];
  const fieldsets = variantSelects.querySelectorAll("fieldset[data-index]");

  for (const fieldset of fieldsets) {
    const handle = (fieldset.getAttribute("data-handle") || "").toLowerCase();
    const optionKey = fieldset.getAttribute("data-index");
    if (
      optionKey &&
      colorNames.some((name) => handle.includes(name)) &&
      variant[optionKey] != null
    ) {
      return optionKey;
    }
  }

  return null;
}

function normalizeImageSetValue(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
}

function normalizeImageGroup(group) {
  const raw = String(group || "").trim();
  if (!raw) return "";

  const underscore = raw.indexOf("_");
  if (underscore === -1) return raw.toLowerCase();

  const setName = raw.slice(0, underscore);
  const setValue = raw.slice(underscore + 1);
  return `${setName}_${normalizeImageSetValue(setValue)}`;
}

window.normalizeSpringlaneImageGroup = normalizeImageGroup;

function getAllowedVariantIds(container, variantId) {
  const variantSelects = container.querySelector("variant-selects, variant-radios");
  if (!variantSelects) return [String(variantId)];

  const script = variantSelects.querySelector('script[type="application/json"]');
  if (!script) return [String(variantId)];

  let variants;
  try {
    variants = JSON.parse(script.textContent);
  } catch {
    return [String(variantId)];
  }

  const current = variants.find((variant) => String(variant.id) === String(variantId));
  if (!current) return [String(variantId)];

  let optionKey = variantSelects.dataset.imageSetIndex || null;
  if (!optionKey || current[optionKey] == null) {
    optionKey = detectColorOptionKey(current, variantSelects);
  }

  if (!optionKey || current[optionKey] == null) {
    return [String(variantId)];
  }

  const optionValue = current[optionKey];
  return variants
    .filter((variant) => variant[optionKey] === optionValue)
    .map((variant) => String(variant.id));
}

function getVariantFromContainer(container, variantId) {
  const variantSelects = container.querySelector("variant-selects, variant-radios");
  if (!variantSelects) return null;

  const script = variantSelects.querySelector('script[type="application/json"]');
  if (!script) return null;

  try {
    const variants = JSON.parse(script.textContent);
    return variants.find((variant) => String(variant.id) === String(variantId)) || null;
  } catch {
    return null;
  }
}

function getActiveImageGroup(container, variantId) {
  const variantSelects = container.querySelector("variant-selects, variant-radios");
  const sampleSlide = container.querySelector(
    ".product-images__slide[data-set-name][data-group]"
  );
  if (!variantSelects || !sampleSlide) return null;

  const imageSetName = sampleSlide.getAttribute("data-set-name");
  if (!imageSetName) return null;

  const current = getVariantFromContainer(container, variantId);
  if (!current) return null;

  const sectionId = variantSelects.dataset.section;
  if (current.featured_media && sectionId) {
    const featuredSlide = container.querySelector(
      `#Slide-${sectionId}-${current.featured_media.id}`
    );
    if (featuredSlide && featuredSlide.dataset.group) {
      return normalizeImageGroup(featuredSlide.dataset.group);
    }
  }

  let optionKey = variantSelects.dataset.imageSetIndex || null;
  if (!optionKey || current[optionKey] == null) {
    optionKey = detectColorOptionKey(current, variantSelects);
  }
  if (!optionKey || current[optionKey] == null) return null;

  const target = `${imageSetName}_${normalizeImageSetValue(current[optionKey])}`;
  const available = new Set();
  container.querySelectorAll("[data-group]").forEach((el) => {
    available.add(normalizeImageGroup(el.getAttribute("data-group")));
  });

  if (available.has(target)) return target;

  const prefix = `${imageSetName}_`;
  const matches = [...available].filter((group) => group.startsWith(prefix));
  return matches.length === 1 ? matches[0] : target;
}

function applyVariantMediaVisibility(container, newVariantId) {
  if (!newVariantId) return;

  const allowedIds = new Set(getAllowedVariantIds(container, newVariantId));
  const activeGroup = getActiveImageGroup(container, newVariantId);

  const toggleVisibility = (element) => {
    const sid = (element.getAttribute("data-variant-id") || "").trim();
    const group = (element.getAttribute("data-group") || "").trim();

    if (group) {
      element.classList.remove("hidden");
      return;
    }

    let hide = false;
    if (activeGroup && sid) {
      hide = !allowedIds.has(sid);
    } else if (sid) {
      hide = !allowedIds.has(sid);
    }

    element.classList.toggle("hidden", hide);
  };

  container.querySelectorAll(".product-images__slide").forEach(toggleVisibility);
  container.querySelectorAll(".product-thumbnail").forEach(toggleVisibility);
}

function snapshotVariantMediaHidden(container) {
  const slides = [];
  const thumbnails = [];
  container.querySelectorAll(".product-images__slide").forEach((el) => {
    slides.push({ el, hidden: el.classList.contains("hidden") });
  });
  container.querySelectorAll(".product-thumbnail").forEach((el) => {
    thumbnails.push({ el, hidden: el.classList.contains("hidden") });
  });
  return { slides, thumbnails };
}

function restoreVariantMediaHidden(snapshot) {
  snapshot.slides.forEach(({ el, hidden }) => {
    el.classList.toggle("hidden", hidden);
  });
  snapshot.thumbnails.forEach(({ el, hidden }) => {
    el.classList.toggle("hidden", hidden);
  });
}

function hasVisibleVariantMedia(container) {
  if (!container.querySelector(".product-images__slide:not(.hidden)")) {
    return false;
  }
  const thumbs = container.querySelectorAll(".product-thumbnail");
  if (thumbs.length === 0) return true;
  return !!container.querySelector(".product-thumbnail:not(.hidden)");
}

function applyVariantMediaVisibilityOrKeepPrevious(container, newVariantId) {
  if (!newVariantId) return;

  const before = snapshotVariantMediaHidden(container);
  applyVariantMediaVisibility(container, newVariantId);
  if (hasVisibleVariantMedia(container)) {
    return;
  }
  restoreVariantMediaHidden(before);
}

window.applySpringlaneVariantMediaVisibility = applyVariantMediaVisibilityOrKeepPrevious;

function refreshVisibleMediaImages(container) {
  if (!container) return;

  const images = container.querySelectorAll(
    ".product-thumbnail:not(.hidden) img.lazyload, .product-thumbnail:not(.hidden) img.lazyloading, " +
      ".product-images__slide.is-active:not(.hidden) img.lazyload, .product-images__slide.is-active:not(.hidden) img.lazyloading"
  );

  images.forEach((img) => {
    if (window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.unveil(img);
    }
  });

  if (window.lazySizes && window.lazySizes.loader) {
    window.lazySizes.loader.checkElems();
  }
}

window.refreshSpringlaneVisibleMediaImages = refreshVisibleMediaImages;

function resolveProductDetailFromVariantEvent(detail) {
  const sectionId = detail && detail.sectionId;
  if (!sectionId) {
    return document.querySelector(".thb-product-detail");
  }
  const root = document.querySelector(
    `variant-selects[data-section="${sectionId}"]`
  );
  return root ? root.closest(".thb-product-detail") : null;
}

function selectFirstVisibleThumbnail(container) {
  const productSlider = container.querySelector("product-slider.product-images");
  if (!productSlider) return;

  const variantSelects = container.querySelector("variant-selects, variant-radios");
  const hasImageSet = container.querySelector(".product-images__slide[data-set-name]");

  if (hasImageSet && variantSelects && typeof variantSelects.setImageSetMedia === "function") {
    variantSelects.setImageSetMedia();
  } else {
    container.querySelectorAll(".product-images__slide").forEach((slide) => {
      slide.classList.toggle("is-active", !slide.classList.contains("hidden"));
    });
    container.querySelectorAll(".product-thumbnail").forEach((thumb) => {
      thumb.classList.toggle("is-active", !thumb.classList.contains("hidden"));
    });
  }

  container.querySelectorAll(".is-initial-selected").forEach((el) => {
    el.classList.remove("is-initial-selected");
  });

  const firstSlide =
    container.querySelector(".product-images__slide.is-active:not(.hidden)") ||
    container.querySelector(".product-images__slide:not(.hidden)");
  const firstThumb =
    (firstSlide &&
      firstSlide.id &&
      container.querySelector("#" + firstSlide.id.replace(/^Slide-/, "Thumb-"))) ||
    container.querySelector(".product-thumbnail.is-active:not(.hidden)") ||
    container.querySelector(".product-thumbnail:not(.hidden)");

  if (firstSlide) firstSlide.classList.add("is-initial-selected");
  if (firstThumb) firstThumb.classList.add("is-initial-selected");

  if (!firstSlide) return;

  if (typeof productSlider.setOptions === "function") {
    productSlider.setOptions();
  }

  if (typeof productSlider.reInit === "function") {
    productSlider.reInit(0);
  } else if (typeof productSlider.syncToInitialSelected === "function") {
    productSlider.syncToInitialSelected();
  }

  requestAnimationFrame(() => {
    refreshVisibleMediaImages(container);
    if (productSlider.flkty) {
      productSlider.flkty.resize();
    }
  });
}

function reinitializeProductImageSliderWhenReady(container, attempt) {
  const n = typeof attempt === "number" ? attempt : 0;
  const maxAttempts = 90;
  const slider = container.querySelector("product-slider.product-images");
  if (!slider) return;

  if (!slider.flkty && n < maxAttempts) {
    requestAnimationFrame(() =>
      reinitializeProductImageSliderWhenReady(container, n + 1)
    );
    return;
  }

  selectFirstVisibleThumbnail(container);
}

document.addEventListener("product:variant-change", (event) => {
  const detail = event.detail || {};
  const variant = detail.variant;
  if (!variant || variant.id == null) return;

  const scope = resolveProductDetailFromVariantEvent(detail);
  if (!scope) return;

  const variantSelects = scope.querySelector("variant-selects, variant-radios");

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (variantSelects) {
        if (typeof variantSelects.ensureImageSetIndex === "function") {
          variantSelects.ensureImageSetIndex();
        }
        if (typeof variantSelects.setImageSetMedia === "function") {
          variantSelects.setImageSetMedia();
        }
      }

      selectFirstVisibleThumbnail(scope);
      refreshVisibleMediaImages(scope);
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".product-grid-container");
  if (!section) return;

  const container = section.closest(".thb-product-detail");
  if (!container) return;

  const thumbnailsStart = section.querySelectorAll(".product-thumbnail:not(.hidden)");
  const slidesStart = section.querySelectorAll(".product-images__slide:not(.hidden)");
  const slides = section.querySelectorAll(".product-images__slide");
  const thumbnails = section.querySelectorAll(".product-thumbnail");

  if (thumbnailsStart.length === 0 || slidesStart.length === 0) {
    thumbnails.forEach((thumbnail) => thumbnail.classList.toggle("hidden", false));
    slides.forEach((slide) => slide.classList.toggle("hidden", false));
  }

  const initialVariantId =
    getVariantIdFromProductForm(container) || getCheckedColorVariantId(container);
  if (initialVariantId) {
    applyVariantMediaVisibilityOrKeepPrevious(container, initialVariantId);
  }

  reinitializeProductImageSliderWhenReady(container);
});
